import useIsMounted from './useIsMounted'

// Renders `serverValue` for the first client render so it still matches the prerendered HTML, then
// `liveValue` from the next render on. Order matters: transposing the two reintroduces the mismatch.
export default function useSsrSafeValue<T>(serverValue: T, liveValue: T): T {
  const isMounted = useIsMounted()
  return isMounted ? liveValue : serverValue
}
